import React  from 'react';
import { Card, CardContent, Container, Grid, Typography } from "@mui/material";
import RoomIcon from '@mui/icons-material/Room';
import { useRecoilValue } from "recoil";
import { blueGrey } from "@mui/material/colors";
import ScheduleTimeButtom from "src/shared/components/buttons/ScheduleTimeButtom";
import { userState } from 'src/store/user/userState'
import { isSexFemale, isSexIndeterminate, isSexMale } from "src/shared/global/helpers";
import ManageStorage from "src/shared/global/manageStorage";

const SubHeaderUserRegistered = () => {
    const { payload } = useRecoilValue(userState);
    const { uswNombres, uswApePat, uswApeMat, isaNombre, genNombre } = payload || {};
    const currentUrl = ManageStorage.getValueFromStorage("currentUrl");

    const welcomeUserText = (genNombre) => {
        let welcome = 'Bienvenid';
        let letterChange = '(a)';

        if (isSexMale(genNombre)) letterChange = `o`;
        if (isSexFemale(genNombre)) letterChange = `a`;
        if (isSexIndeterminate(genNombre)) letterChange = `(a)`;

        return `${welcome}${letterChange}`;
    }

    return (
        <Container>
            <Card sx={{ background: "transparent", boxShadow: 'none' }}>
                <CardContent style={{ padding: 0 }}>
                    <Grid container alignItems={"center"}>
                        <Grid item xs={12} md={9}>
                            <Typography textAlign={"start"} variant="h6" color={blueGrey[100]}>
                                {welcomeUserText(genNombre)},
                            </Typography>
                            <Typography textAlign="start" variant="h2" color="white" paddingY={1} fontWeight={900} style={{ textTransform: "uppercase" }}>
                                {`${uswNombres || ''} ${uswApePat || ''} ${uswApeMat || ''}`}
                            </Typography>

                            <Typography style={{ display: 'flex', }} textAlign="start" variant="h6" color={blueGrey[100]} lineHeight={"30px"} gutterBottom>
                                <RoomIcon style={{ marginLeft: '-4px' }} /> {process.env.REACT_APP_SEDE} {isaNombre ? `- ${isaNombre}` : ''}
                            </Typography>
                        </Grid>

                        {
                            currentUrl && !currentUrl.includes('/resultado-busqueda') && (
                                <Grid item xs={12} md={3} paddingY={2}>
                                    <ScheduleTimeButtom />
                                </Grid>
                            )
                        }
                    </Grid>
                </CardContent>
            </Card>
        </Container >

    );
}

export default SubHeaderUserRegistered
